import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { GridColumns } from '@mui/x-data-grid-pro';

export const getPassportPreCheckGridColumns = (t): GridColumns => {
  const defaultPassportPreCheckColumn = {
    ...XGridDefaultColumn,
    flex: 0,
  };

  return [
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.skillsets'),
      field: 'skillsets',
      width: 215,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.locations'),
      field: 'locations',
      width: 300,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.surroundingAreas'),
      field: 'surroundingAreas',
      width: 175,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.minimumPay'),
      field: 'minimumPay',
      width: 215,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.earliestAvailabilty'),
      field: 'earliestAvailabilty',
      width: 230,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.shiftTime'),
      field: 'shiftTime',
      width: 175,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.shiftLength'),
      field: 'shiftLength',
      width: 175,
    },
    {
      ...defaultPassportPreCheckColumn,
      headerName: t('candidate.passportPreCheckPreferences.lastUpdated'),
      field: 'lastUpdated',
      width: 175,
    },
  ];
};

export const getPassportPreCheckGridVisibilityModel = {
  skillsets: true,
  locations: true,
  surroundingAreas: true,
  minimumPay: true,
  earliestAvailabilty: true,
  shiftTime: true,
  shiftLength: true,
  lastUpdated: true,
};

